module.exports = __webpack_public_path__ + "static/Skateboard-Small-a66bf731c5e46fd2350b81897af607b6.png";